import TournamentTypeBadge from '@/client/components/Tournaments/TournamentTypeBadge';
import TournamentTypeIndicator from '@/client/components/Tournaments/TournamentTypeIndicator';
import { TournamentFragment } from '@/shared/graphql/TournamentFragment.generated';

type Props = {
  tournament: TournamentFragment;
  translations: Record<string, string>;
  isMobile?: boolean;
  isBitcasino: boolean;
};

const TournamentInfo: FC<Props> = ({
  tournament,
  translations,
  isMobile,
  isBitcasino,
}) => (
  <div className="grid gap-1 px-0 py-2">
    <div className="flex w-full gap-3">
      <TournamentTypeBadge
        status={tournament.activityType as TournamentStatus}
        won={false}
        translations={translations}
        isBitcasino={isBitcasino}
      />
      <TournamentTypeIndicator
        type={tournament.leaderboardType}
        tooltipPosition="bottom-start"
        isGameBanner
        translations={translations}
        isMobile={isMobile}
      />
    </div>
    <span
      data-testid={tournament.name}
      className="line-clamp-2 font-headline text-moon-18"
    >
      {tournament.name}
    </span>
  </div>
);

export default TournamentInfo;
